import React, { useEffect } from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { aside as frAside } from '../../../../locales/fr/aside';
import { aside as arAside } from '../../../../locales/ar/aside';
import { aside as esAside } from '../../../../locales/es/aside';
import useMyAppStore from '../../../../stores/myAppStore';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const MouvementsCaisse = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { setPageTitle } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.cashMovements);
  }, [lang, t.routes.cashMovements, setPageTitle]);

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-8">
          {t.routes.cashMovements}
        </h1>
      </div>
    </div>
  );
};

export default MouvementsCaisse; 